// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false;

var selfServiceLocation;
switch(process.env.NODE_ENV) {
  case 'development':
    selfServiceLocation = 'http://127.0.0.1:6677/api/v1';
    break;
  case 'production': 
    selfServiceLocation = 'https://api.live.alchemy-connect.com/mytrade/api/v1';
    break;
  case 'uat':
    selfServiceLocation = 'https://api.uat.alchemy-connect.com/mytrade/api/v1';
    break;
}
Vue.prototype.$selfServiceLocation = selfServiceLocation;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js